module.exports = __webpack_public_path__ + "img/CM-MR-26-Ford-Lifestyle.e1c7587c.jpg";